import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { RouterView, type RouterOptions } from "vue-router";
import { asbestosEnforcementActionRouteName } from "../enforcementAction/enforcementAction";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosEnforcementActions: "AsbestosEnforcementAction.AsbestosEnforcementActions",
  list: "AsbestosEnforcementAction.AsbestosEnforcementActionsList",
  // new: "AsbestosEnforcementAction.AsbestosEnforcementActionNew",
  base: "AsbestosEnforcementAction.AsbestosEnforcementActionBase",
  view: "AsbestosEnforcementAction.AsbestosEnforcementActionView",
  edit: "AsbestosEnforcementAction.AsbestosEnforcementActionEdit",
  documents: "AsbestosEnforcementAction.AsbestosEnforcementActionDocuments",
  documentsEdit: "AsbestosEnforcementAction.AsbestosEnforcementActionDocumentsEdit",
  documentsNew: "AsbestosEnforcementAction.AsbestosEnforcementActionDocumentsNew",
  audit: "AsbestosEnforcementAction.AsbestosEnforcementActionAudit",
};

export { names as asbestosEnforcementActionRouteNames };

const asbestosEnforcementActionRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosEnforcementAction",
    name: names.asbestosEnforcementActions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Asbestos Enforcement Actions",
          lookupGroups: ["DeliveryMethod", "EnforcementActionType", "InspectionCategory"],
        },
        component: () => import("@/views/asbestosEnforcementActions/AsbestosEnforcementActionsList.vue"),
      },
      // {
      //   path: "new/:inspectionId(\\d+)?",
      //   component: () => import("@/views/asbestosEnforcementActions/AsbestosEnforcementActionBase.vue"),
      //   redirect: { name: names.new },
      //   props: true,
      //   children: [
      //     {
      //       path: "",
      //       name: names.new,
      //       meta: { title: "New Enforcement Action", isNew: true },
      //       component: () => import("@/views/asbestosEnforcementActions/AsbestosEnforcementActionEdit.vue"),
      //     },
      //   ],
      // },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosEnforcementActions/AsbestosEnforcementActionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Enforcement Action View" },
            component: () => import("@/views/enforcementAction/EnforcementActionView.vue"),
            props: { entityRouteName: asbestosEnforcementActionRouteName },
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Asbestos Enforcement Action Edit", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionEdit.vue"),
            props: { entityRouteName: asbestosEnforcementActionRouteName },
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Asbestos Enforcement Action Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="asbestosEnforcementAction" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Asbestos Enforcement Action Document", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocument.vue"),
            props: { resourceTypeKey: "asbestosEnforcementAction" },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Asbestos Enforcement Action Documents", isForm: true },
            component: () => import("@/views/enforcementAction/EnforcementActionDocuments.vue"),
            props: { resourceTypeKey: "asbestosEnforcementAction" },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Enforcement Action Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="EnforcementAction" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosEnforcementActionRoutes;
